import { render } from "./SoEasy.vue?vue&type=template&id=78d60454&scoped=true"
import script from "./SoEasy.vue?vue&type=script&lang=js"
export * from "./SoEasy.vue?vue&type=script&lang=js"

import "./SoEasy.vue?vue&type=style&index=0&id=78d60454&lang=scss&scoped=true"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d60454"]])

export default __exports__